export const groupData = [
  {
    key:"1",
    Group_Img: "group-01.jpg",
    Group_Name: "The Dream Team",
    Group_Description:
      "Design enthusiasts unite! Share, learn, and create together!",
    Img_One: "user-01.jpg",
    Img_Two: "user-02.jpg",
    Img_Three: "user-03.jpg",
    Img_Four: "user-04.jpg",
    Img_Five: "user-05.jpg",
    Members: "35+",
    Total_Chat_Count: "105",
    Created_Date: "02 Sep 2024, 10:00 AM",
  },
  {
    key:"2",
    Group_Img: "group-02.jpg",
    Group_Name: "The Meme Team",
    Group_Description: "Welcome to the Meme Team! Share and enjoy memes!",
    Img_One: "user-06.jpg",
    Img_Two: "user-07.jpg",
    Img_Three: "user-08.jpg",
    Img_Four: "user-09.jpg",
    Img_Five: "user-10.jpg",
    Members: "40+",
    Total_Chat_Count: "120",
    Created_Date: "14 Sep 2024, 11:30 AM",
  },
  {
    key:"3",
    Group_Img: "group-03.jpg",
    Group_Name: "Tech Talk Tribe",
    Group_Description: "Share insights, ask questions, and explore new trends!",
    Img_One: "user-03.jpg",
    Img_Two: "user-02.jpg",
    Img_Three: "user-01.jpg",
    Img_Four: "user-08.jpg",
    Img_Five: "user-05.jpg",
    Members: "20+",
    Total_Chat_Count: "200",
    Created_Date: "28 Sep 2024, 08:15 AM",
  },
  {
    key:"4",
    Group_Img: "group-04.jpg",
    Group_Name: "Game Changers",
    Group_Description: "Game on! Share tips, play together, and have fun!",
    Img_One: "user-04.jpg",
    Img_Two: "user-09.jpg",
    Img_Three: "user-06.jpg",
    Img_Four: "user-01.jpg",
    Img_Five: "user-02.jpg",
    Members: "15+",
    Total_Chat_Count: "250",
    Created_Date: "12 Oct 2024, 06:40 PM",
  },
  {
    key:"5",
    Group_Img: "group-05.jpg",
    Group_Name: "The Chill Zone",
    Group_Description: "Chill vibes only! Relax, chat, and unwind.",
    Img_One: "user-01.jpg",
    Img_Two: "user-02.jpg",
    Img_Three: "user-03.jpg",
    Img_Four: "user-04.jpg",
    Img_Five: "user-09.jpg",
    Members: "30+",
    Total_Chat_Count: "300",
    Created_Date: "20 Oct 2024, 04:18 PM",
  },
  {
    key:"6",
    Group_Img: "group-06.jpg",
    Group_Name: "Squad Goals",
    Group_Description: "Squad goals! Connect, plan, and have a blast together.",
    Img_One: "user-05.jpg",
    Img_Two: "user-08.jpg",
    Img_Three: "user-06.jpg",
    Img_Four: "user-10.jpg",
    Img_Five: "user-04.jpg",
    Members: "25+",
    Total_Chat_Count: "180",
    Created_Date: "30 Oct 2024, 07:25 AM",
  },
  {
    key:"7",
    Group_Img: "group-07.jpg",
    Group_Name: "Scholars Society",
    Group_Description:
      "Share knowledge, discuss ideas, and support each other.",
    Img_One: "user-01.jpg",
    Img_Two: "user-02.jpg",
    Img_Three: "user-03.jpg",
    Img_Four: "user-04.jpg",
    Img_Five: "user-05.jpg",
    Members: "28+",
    Total_Chat_Count: "200",
    Created_Date: "01 Nov 2024, 08:50 AM",
  },
  {
    key:"8",
    Group_Img: "group-08.jpg",
    Group_Name: "Travel Tribe",
    Group_Description:
      '"Explore together! Share travel tips, stories, and adventures"',
    Img_One: "user-03.jpg",
    Img_Two: "user-08.jpg",
    Img_Three: "user-01.jpg",
    Img_Four: "user-04.jpg",
    Img_Five: "user-03.jpg",
    Members: "35+",
    Total_Chat_Count: "320",
    Created_Date: "10 Nov 2024, 11:20 AM",
  },
  {
    key:"9",
    Group_Img: "group-09.jpg",
    Group_Name: "Fitness Fanatics",
    Group_Description:
      "Get fit together! Share workouts, tips, and motivation.",
    Img_One: "user-01.jpg",
    Img_Two: "user-02.jpg",
    Img_Three: "user-03.jpg",
    Img_Four: "user-09.jpg",
    Img_Five: "user-07.jpg",
    Members: "40+",
    Total_Chat_Count: "400",
    Created_Date: "17 Nov 2024, 04:50 PM",
  },
  {
    key:"10",
    Group_Img: "group-10.jpg",
    Group_Name: "Movie Buffs",
    Group_Description:
      "Movie buffs unite! Discuss, review, and enjoy films together.",
    Img_One: "user-05.jpg",
    Img_Two: "user-02.jpg",
    Img_Three: "user-03.jpg",
    Img_Four: "user-09.jpg",
    Img_Five: "user-07.jpg",
    Members: "50+",
    Total_Chat_Count: "210",
    Created_Date: "12 Dec 2024, 09:30 AM",
  },
];